import { AppNoticeAPI } from 'components/appNotices/types';
import { useAppNotices } from 'components/appNotices/useAppNotices';
import { Incident } from 'components/statusPage/types';
import { useActiveIncidents } from 'components/statusPage/useActiveIncidents';

export const useActiveIncidentsAndAppNotices = (): {
  isLoading: boolean;
  activeIncidents: Incident[];
  appNotices: AppNoticeAPI[];
} => {
  const { isLoading: isLoadingIncidents, data: activeIncidents } =
    useActiveIncidents();
  const { isLoading: isLoadingAppNotices, data: appNotices } = useAppNotices();

  return {
    isLoading: isLoadingIncidents || isLoadingAppNotices,
    activeIncidents,
    appNotices
  };
};
